import React, { useEffect, useRef } from 'react';
import { Chart, ChartConfiguration, registerables } from 'chart.js';

Chart.register(...registerables);

interface TrendChartProps {
  data: {
    labels: string[];
    datasets: {
      label: string;
      data: (number | undefined | null)[];
      borderColor: string;
      backgroundColor: string;
      tension?: number;
    }[];
  };
}

const CollisionRiskTrendChart: React.FC<TrendChartProps> = ({ data }) => {
  const chartRef = useRef<HTMLCanvasElement>(null);
  const chartInstanceRef = useRef<Chart | null>(null);

  useEffect(() => {
    if (chartRef.current) {
      if (chartInstanceRef.current) {
        chartInstanceRef.current.destroy();
      }

      const ctx = chartRef.current.getContext('2d');
      if (ctx) {
        const config: ChartConfiguration = {
          type: 'line',
          data: data,
          options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              legend: {
                display: false,
              },
            },
            scales: {
              y: {
                min: 1000,
                max: 10000,
                ticks: {
                  color: '#64748b',
                },
                grid: {
                  color: '#e2e8f0',
                },
              },
              x: {
                ticks: {
                  color: '#64748b',
                },
                grid: {
                  display: false,
                },
              },
            },
          },
        };
        chartInstanceRef.current = new Chart(ctx, config);
      }
    }

    return () => {
      if (chartInstanceRef.current) {
        chartInstanceRef.current.destroy();
        chartInstanceRef.current = null;
      }
    };
  }, [data]);

  return <canvas ref={chartRef} />;
};

export default CollisionRiskTrendChart;
